exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-snippet-outline {\n  outline: 1px solid var(--gray-200);\n  outline-offset: 6px;\n}\n", ""]);

// exports
